<div (clickOutside)="showDropdown = false">
	<span class="button" (click)="showDropdown = !showDropdown">
		<i class="fa fa-{{icon}}"></i>{{ label }}
	</span>
	<div [hidden]="!showDropdown" class="dropdown-wrapper">
		<ng-content select="ul"></ng-content>
	</div>
</div>
